import requestFunctions from "../../functions/requestFunctions";


export const state = {
  SHOPS_ITEM: {},
  SHOPS_LIST: [],
  SHOPS_TABLE_DATA: [],
  SHOPS_ARRAY_DATA: [],
  SHOPS_TOTAL_ROWS: 0
}

export const getters = {
  GET_SHOPS_ITEM: (state) => {
    return state.SHOPS_ITEM;
  },
  GET_SHOPS_LIST: (state) => {
    return state.SHOPS_LIST;
  },
  GET_SHOPS_TABLE_DATA: (state) => {
    return state.SHOPS_TABLE_DATA;
  },
  GET_SHOPS_ARRAY_DATA: (state) => {
    return state.SHOPS_ARRAY_DATA;
  },
  GET_SHOPS_TOTAL_ROWS: (state) => {
    return state.SHOPS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_SHOPS_ITEM(state, item) {
    state.SHOPS_ITEM = item;
  },

  UPDATE_SHOPS_LIST(state, list) {
    
    state.SHOPS_LIST = list.data;

    state.SHOPS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.SHOPS_TABLE_DATA = [];
    state.SHOPS_ARRAY_DATA = [];

    let status;

    list.forEach(el => {

      status = ''
      if(el.status === 'active'){
        status = 'Активен'
      }
      if(el.status === 'not_active'){
        status = 'Неактивен'
      }
      
      state.SHOPS_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id'   : el.id,
        'name' : el.name,
        'status' : status,
        'api_key': el.api_key,
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,        
        'comments'   : el.comments,        
        'company_name' : el.company_name,
        'marketplace_name' : el.marketplace_name,        
      });

      state.SHOPS_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name
      });
    });
  },
}

export const actions = {

  async FETCH_SHOPS_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/shops/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_SHOPS_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_SHOPS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/shops';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_SHOPS_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_SHOPS_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/shops';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_SHOPS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/shops/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_SHOPS_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/shops/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}